// extracted by mini-css-extract-plugin
export default {"container":"OraclePage_container__WnHQ+"};